export const labels = {
  appName: 'ניהול מעשרות ותרומות',
  appShort: 'מעשרות',
  signIn: 'התחברות עם Google',
  signOut: 'התנתקות',
  dashboard: 'לוח בקרה',
  reports: 'דוחות חודשיים',
  fixedDonations: 'תרומות קבועות',
  auditLog: 'יומן פעילות',
  members: 'חברי משק בית',
  household: 'משק בית',
  createHousehold: 'יצירת משק בית',
  joinHousehold: 'הצטרפות למשק בית',
  householdName: 'שם משק הבית',
  inviteCode: 'קוד הזמנה',
  join: 'הצטרף',
  create: 'צור',
  save: 'שמירה',
  cancel: 'ביטול',
  delete: 'מחיקה',
  edit: 'עריכה',
  export: 'ייצוא',
  exportExcel: 'ייצוא ל-Excel',
  newReport: 'דוח חודשי חדש',
  createReport: 'יצירת דוח',
  month: 'חודש',
  year: 'שנה',
  income: 'הכנסות',
  memberIncome: 'הכנסת חבר',
  additionalIncome: 'הכנסות נוספות',
  totalIncome: 'סה״כ הכנסות',
  maaser: 'מעשר',
  maaserRequired: 'חובת מעשר',
  maaserDebt: 'חוב מעשר',
  maaserCredit: 'זיכוי מעשר',
  debtFromPreviousMonths: 'חוב מעשר מחודשים קודמים',
  applyCreditFromPrevious: 'החלת זיכוי מחודש קודם',
  applyCreditHint: 'זיכוי לא מוחל אוטומטית — יש לבחור במפורש בכל חודש',
  fixedDonationsTotal: 'סה״כ תרומות קבועות',
  oneTimeDonations: 'תרומות חד-פעמיות',
  oneTimeDonationsTotal: 'סה״כ תרומות חד-פעמיות',
  amountDue: 'יתרה לתשלום',
  monthlyFinancialResult: 'מאזן חודשי',
  monthBalanceSummary: 'יתרת חודש',
  maaserPaid: 'מעשר ששולם',
  monthlyFinancialChart: 'מאזן חודשי',
  monthlyMaaserPaidChart: 'מעשר ששולם לפי חודש',
  tooltipMonth: 'חודש',
  tooltipMonthlyResult: 'מאזן חודשי',
  tooltipStatus: 'סטטוס',
  statusPositive: 'חובה',
  statusNegative: 'זיכוי',
  statusBalanced: 'מאוזן',
  description: 'תיאור',
  amount: 'סכום',
  displayName: 'שם תצוגה',
  displayNameLabel: 'שם לתצוגה',
  addEntry: 'הוספת רשומה',
  noData: 'אין נתונים להצגה',
  loading: 'טוען...',
  unsavedChanges: 'יש שינויים שלא נשמרו',
  saved: 'נשמר בהצלחה',
  deleted: 'נמחק',
  undo: 'ביטול מחיקה',
  owner: 'בעלים',
  member: 'חבר',
  removeMember: 'הסרת חבר',
  generateInvite: 'יצירת קוד הזמנה',
  copyCode: 'העתקת קוד',
  copied: 'הועתק',
  filterByMonth: 'סינון לפי חודש',
  filterByUser: 'סינון לפי משתמש',
  allMonths: 'כל החודשים',
  allUsers: 'כל המשתמשים',
  actionCreate: 'יצירה',
  actionUpdate: 'עדכון',
  actionDelete: 'מחיקה',
  startDate: 'תאריך התחלה',
  endDate: 'תאריך סיום (אופציונלי)',
  donationName: 'שם התרומה',
  deleteFixedDonation: 'מחיקת תרומה קבועה',
  confirmDelete: 'האם למחוק?',
  confirmDeleteDesc: 'פעולה זו תימחק. ניתן לבטל תוך 5 שניות.',
  undoDeleteHint: 'ניתן לבטל את המחיקה תוך 5 שניות',
  searchDonations: 'חיפוש תרומות',
  showActiveOnly: 'הצג רק פעילות',
  confirmDonationChange: 'עדכון ישפיע על דוחות קיימים',
  confirmDonationChangeDesc: 'שינוי זה יחשב מחדש את הדוחות החודשיים המושפעים. להמשיך?',
  joinedHousehold: 'הצטרפתם למשק הבית בהצלחה',
  createdHousehold: 'משק הבית נוצר בהצלחה',
  errorGeneric: 'אירעה שגיאה. נסו שוב.',
  errorAuth: 'שגיאת התחברות. התחברו מחדש.',
  errorPermission: 'אין הרשאה לבצע פעולה זו.',
  errorNotFound: 'הפריט לא נמצא.',
  errorNetwork: 'בעיית רשת. בדקו את החיבור.',
  errorDuplicateReport: 'דוח לחודש זה כבר קיים',
  errorFirebaseNotConfigured: 'Firebase לא מוגדר. הגדירו משתני סביבה.',
  noHousehold: 'לא נבחר משק בית',
  selectHousehold: 'בחרו או צרו משק בית להמשך',
  welcome: 'ברוכים הבאים',
  agorotNote: 'כל הסכומים בשקלים',
  editDonation: 'עריכת תרומה',
  newDonation: 'תרומה קבועה חדשה',
  continueToReport: 'המשך לעריכת הדוח',
  calculations: 'חישובים',
  currentMonth: 'חודש נוכחי',
  previousMonth: 'חודש קודם',
} as const
